// 本地存储服务
class StorageService {
  private readonly REMEMBER_PASSWORD_KEY = 'fanghu_remember_password';
  private readonly REMEMBERED_USERNAME_KEY = 'fanghu_remembered_username';
  private readonly REMEMBERED_PASSWORD_KEY = 'fanghu_remembered_password';

  // 保存记住密码状态
  saveRememberPassword(remember: boolean): void {
    localStorage.setItem(this.REMEMBER_PASSWORD_KEY, JSON.stringify(remember));
  }

  // 获取记住密码状态
  getRememberPassword(): boolean {
    const value = localStorage.getItem(this.REMEMBER_PASSWORD_KEY);
    return value ? JSON.parse(value) : false;
  }

  // 保存记住的用户名和密码
  saveRememberedCredentials(username: string, password: string): void {
    localStorage.setItem(this.REMEMBERED_USERNAME_KEY, username);
    localStorage.setItem(this.REMEMBERED_PASSWORD_KEY, password);
  }

  // 获取记住的用户名
  getRememberedUsername(): string | null {
    return localStorage.getItem(this.REMEMBERED_USERNAME_KEY);
  }

  // 获取记住的密码
  getRememberedPassword(): string | null {
    return localStorage.getItem(this.REMEMBERED_PASSWORD_KEY);
  }

  // 清除记住的凭据
  clearRememberedCredentials(): void {
    localStorage.removeItem(this.REMEMBERED_USERNAME_KEY);
    localStorage.removeItem(this.REMEMBERED_PASSWORD_KEY);
    localStorage.removeItem(this.REMEMBER_PASSWORD_KEY);
  }

  // 检查是否有记住的凭据
  hasRememberedCredentials(): boolean {
    return !!(this.getRememberedUsername() && this.getRememberedPassword());
  }
}

export const storageService = new StorageService(); 